"use client";

import React from "react";
import { defaultTheme } from "@/src/config/colors";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  icon?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  helperText,
  icon,
  className = "",
  ...props
}) => {
  return (
    <div className="w-full flex flex-col gap-1">
      {label && (
        <label className="text-sm font-medium" style={{ color: defaultTheme.text.primary }}>
          {label}
        </label>
      )}
      <div className="relative flex items-center">
        {icon && <div className="absolute left-3">{icon}</div>}
        <input
          className={`w-full px-4 py-2 text-sm border rounded-lg transition-colors duration-200 focus:outline-none ${
            icon ? "pl-10" : ""
          } ${error ? "border-red-500" : "border-gray-300"} focus:border-[${defaultTheme.primary}] ${className}`}
          style={{
            borderColor: error ? "#EF4444" : defaultTheme.border,
          }}
          {...props}
        />
      </div>
      {error && <span className="text-xs text-red-500">{error}</span>}
      {helperText && !error && (
        <span className="text-xs" style={{ color: defaultTheme.text.tertiary }}>
          {helperText}
        </span>
      )}
    </div>
  );
};
